import styled, { css } from 'styled-components';

import { bokehTheme } from '@vimeo/bokeh-theme';

import { AlbumLayouts, AlbumThemes } from '../../types';

type Theme = {
  theme?: AlbumThemes;
};

type Layout = {
  layout?: AlbumLayouts;
};

const darkTheme = css`
  background: ${bokehTheme.colors.gray['800']};

  a {
    color: ${bokehTheme.colors.gray['50']};
  }
`;

const standardTheme = css`
  background: white;
  color: ${bokehTheme.colors.gray['800']};
`;

const standardLayout = css`
  min-height: 100vh;
`;

const featuredLayout = css`
  width: 100%;
  padding: 0;
  min-height: 100vh;
`;

const withTheme = ({ theme }: Theme) => (theme === 'dark' ? darkTheme : standardTheme);
const withLayout = ({ layout }: Layout) => (layout === 'grid' ? standardLayout : featuredLayout);

export const FullHeightWrapper = styled.div<Theme>`
  min-height: 100vh;
  ${withTheme}
`;

export const SiteSection = styled.section<Theme & Layout>`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  margin: 0 auto;
  font-size: 14px;
  line-height: 20px;
  position: relative;

  a,
  a:visited {
    color: ${bokehTheme.colors.gray['800']};
    text-decoration: none;
  }

  a:hover {
    color: ${bokehTheme.colors.blue['500']};
  }

  ${withTheme}
  ${withLayout}
`;
